import { boot } from '@dazn/bootstrap-lib';

type Country = boot.config.AnyCountry;

const languageSegmentRegex = /^\/[a-z]{2}-([a-z]{2})\//i;
const getCountryFromUrl = (pathname: string) => {
    const match = languageSegmentRegex.exec(pathname);
    if (match) {
        const [, country] = match;
        return country.toLowerCase();
    }
    return null;
};

function getCountry(
    startupDataCountry: Country,
    userSignupCountry: Country | undefined,
    pathname: string | null,
    userTokenCountry: Country,
    useSignUpCountry?: boolean,
    isPortable?: boolean,
) {
    if (isPortable && userTokenCountry) {
        return userTokenCountry.toLowerCase();
    }

    if (useSignUpCountry && userSignupCountry) {
        if (window.dazn?.auth?.isVip() && userTokenCountry) {
            return userTokenCountry.toLowerCase();
        }
        return userSignupCountry.toLowerCase();
    }

    if (pathname) {
        const urlCountry = getCountryFromUrl(pathname);
        if (urlCountry) {
            return urlCountry.toLowerCase();
        }
    }

    // startup provides suitable fallback if the country is not in url
    return startupDataCountry.toLowerCase();
}

export { getCountry };
